import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { resolveAppMountBase } from './lib/mountBase'
import './index.css'

const routerBase = resolveAppMountBase(typeof window !== 'undefined' ? window.location.pathname : '/')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={routerBase || undefined}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
// Force rebuild Fri Jan 23 07:03:00 PM UTC 2026
